import _ from "underscore";
import PropTypes from "prop-types";
import React from "react";
import BasicUtils from "../../utils/basic-utils";
import { actions } from "../../utils/overlay-store";
import Button from "../elements/button";

class ModalTriggerDeprecated extends React.Component {
  static displayName = "ModalTriggerDeprecated";

  static propTypes = {
    modal: PropTypes.element.isRequired,
    disable: PropTypes.bool,
    onClick: PropTypes.func,
    buttonType: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  };

  static defaultProps = {
    buttonType: "simple",
  };

  key = BasicUtils.randomKey();

  handleLaunchModal = e => {
    e.preventDefault();
    if (this.props.disable) {
      return;
    }

    const dialog = React.cloneElement(this.props.modal, {
      onClose: this.handleRemove,
      onUnmount: this.handleRemove,
    });

    actions.launchModal(dialog, this.key);
    typeof this.props.onClick === "function" ? this.props.onClick() : undefined;
  };

  handleRemove = () => {
    actions.removeModal(this.key);
    // reset the key once it's removed in case launch again from same trigger
    this.key = BasicUtils.randomKey();
  };

  render() {
    if (this.props.children) {
      const additionalProps = _.omit(this.props, "modal", "disable");
      return (
        <Button
          {..._.extend({}, additionalProps, {
            onClick: this.handleLaunchModal,
            disabled: this.props.disable,
            type: this.props.buttonType,
          })}
        >
          {this.props.children}
        </Button>
      );
    }
    return null;
  }
}
export default ModalTriggerDeprecated;
